import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe, Location, NgClass, DecimalPipe } from '@angular/common';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
// import { UsersService } from '../../../../core/services/users/users.service';
// import { DoctorsService } from '../../../../core/services/doctors/doctors.service';
// import { BsModalRef } from 'ngx-bootstrap/modal';
// import { LeadsService } from '../../../../core/services/leads/leads.service';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpEvent, HttpEventType, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/components/shared/api.service';
import { MainService } from 'src/app/components/shared/main.service';
import { localStorageService } from 'src/app/components/shared/localstorage.service';
import { SharedService } from 'src/app/components/shared/shared.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AssignmentsModalComponent } from '../assignments-modal/assignments-modal.component';
import { AssignmentsService } from '../assignments.service';
import { SocketsService } from 'src/app/components/shared/socket.service';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { PhoneFormatPipe } from '../../../shared/shared.service';
import { PhoneFormatPipe as PhoneFormatPipe_1 } from '../../../shared/pipes/phone-format.pipe';
import { TerminalShipmentModalComponent } from '../terminal-order/terminal-shipment-modal.component';
import {
    hasShipmentDetails,
    parseDeliveryAddress,
    parseLocalDate,
    TerminalDeliveryAddress,
    TERMINAL_ORDER_ACTION_TYPE,
    TERMINAL_TICKET_STATUS_OPTIONS,
    TerminalShipmentModalMode,
    TerminalTicketDevice
} from '../terminal-order/terminal-order.model';

@Component({
    selector: 'app-assignment-details',
    templateUrl: './assignment-details.component.html',
    styleUrls: ['./assignment-details.component.scss'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TooltipDirective, RouterLink, NgClass, DecimalPipe, DatePipe, PhoneFormatPipe, PhoneFormatPipe_1]
})
export class AssignmentDetailsComponent implements OnInit {
    assignment: any = {};
    dispute_docs:any = {}
    role: Number = 0;
    formMetaDataInfo: any;
    isError: any = false;
    newMobile: any;
    changeStatusParams: any = {};
    reassignParams: any;
    update_note: any;
    public mask: any = [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    addNoteParams: any = {
        notes: ''
    };
    zip: any = [];
    loadingZip: any = {
        loading: false,
        loadingError: false,
        data: []
    };
    specialities: any;
    industries: any = [];
    inquiry_email_sent_records: any = [];
    typeaheadLoading: any;
    assigned_admin: any;
    notes: any = [];
    requestId: any;
    id: any;
    timezone: any = this._shared.getTimezone();
    timezoneName: any = this._shared.getTimezoneName();
    // bsModalRef: BsModalRef;
    dateConfig: any = {
        containerClass: 'theme-blue',
        placement: 'left',
        dateInputFormat: 'MM-DD-YYYY'
    };
    today: Date = new Date();
    assigned_to: any;
    timezones: any = this._shared.getTimezoneList();
    phase_info: any = [];
    images: any = [];
    imageURLs: any = [];
    uploading: any;
    fileSubscription: any;
    // @ViewChild('imageElement') imgElement: ElementRef;
    paramSubscription: any;
    hours = [{ value: "00" }, { value: "01" }, { value: "02" }, { value: "03" }, { value: "04" }, { value: "05" }, { value: "06" }, { value: "07" }, { value: "08" }, { value: "09" }, { value: "10" }, { value: "11" }, { value: "12" }, { value: "13" }, { value: "14" }, { value: "15" }, { value: "16" }, { value: "17" }, { value: "18" }, { value: "19" }, { value: "20" }, { value: "21" }, { value: "22" }, { value: "23" }];
    minutes = [{ value: "00" }, { value: "15" }, { value: "30" }, { value: "45" }];
    type_of_call_arr = [];
    result_of_contact_arr: any = [];
    allResultTypeArr: any = [];
    resData: any = {
      pageNumber: 1,
      totalRecords: 0,
    };
    api_request_type: any;
    is_lead: boolean = false;
    lead_request: any;
    queryParamSubscription: any;
    document_required_btn: any
    authDocs: any[] = [];
    terminalDevices: TerminalTicketDevice[] = [];
    deliveryAddress: TerminalDeliveryAddress | null = null;

    constructor(
        public _main: MainService,
        private _assignmentsService: AssignmentsService,
        // public userService: UsersService,
        // public doctorService: DoctorsService,
        private router: Router,
        private route: ActivatedRoute,
        public location: Location,
        public cd: ChangeDetectorRef,
        public datePipe: DatePipe,
        public _api: ApiService,
        public _sanitizer: DomSanitizer,
        public _http: HttpClient,
        public _local: localStorageService,
        private modalService: BsModalService,
        public _shared: SharedService,
        private socket : SocketsService
    ) { }

    ngOnInit() {
        this.today.setHours(0, 0, 0, 0);
        this.paramSubscription = this.route.params.subscribe((data: any) => {
             if (data.id) {
                this.id = data.id;
            }
            this._shared.timezoneName$.subscribe(zones => {
                this.timezones = this._shared.getTimezoneList();
                // if (data.id) {
                //     this.getAssignmentDetails(data.id);
                // }
            })
            // this.is_dummy = data['is_dummy'];
            // this.country_id = data['country_id'];
        })
        this.queryParamSubscription = this.route.queryParams.subscribe((params) => {
            this.api_request_type = Number(params['request_type']);
            this.is_lead = params['is_lead'] == 1;
            this.timezone = params['timezone'];
            this.requestId = params['reqid'] || this.id;
            this.timezones = this._shared.getTimezoneList();
            this.timezones.find((timezone: any) => {
                if (timezone.val == this.timezone) {
                    this.timezoneName = timezone.offset;
                }
            });
        });
        this.paramSubscription = this.route.params.subscribe((data: any) => {
            if (data.id) {
                this.getContactType();
                this.getResultType();
                if (this.is_lead) {
                    this.getLeadRequestDetails(this.requestId || data.id);
                } else {
                    this.getAssignmentDetails(this.requestId || data.id);
                }
            }
            // this._shared.timezoneName$.subscribe(zones => {
            //     this.timezones = this._shared.getTimezoneList();
            //     this.timezones.find((timezone: any) => {
            //         if (timezone.val == this.timezone){
            //             this.timezoneName = timezone.offset;
            //         }
            //     });
            // })
            // this.is_dummy = data['is_dummy'];
            // this.country_id = data['country_id'];
        })
        // console.log('timezones', this.timezones);
    }

    getAssignmentDetails(id: any) {
        let data = {
            req_id: id
        };
        this._api.api(data, 'assignments/csr_request_details', 'get')
            .subscribe((data: any) => {
                if (data && data.result && data.result[0]) {
                    this.document_required_btn = data.result[0].doctor_required_document
                    this.authDocs = data.authDocs || [];
                    this.terminalDevices = data.terminal_devices || [];
                    this.assignment = data.result[0];
                    this.deliveryAddress = parseDeliveryAddress(this.assignment.delivery_address);
                    this.role = this._local.customGetItem('admin_profile') ? (this._local.customGetItem('admin_profile').role_id) : 0;
                    this.phase_info = data.phase_info[0];
                    console.log(this.assignment);
                    if (data.result[0] && data.result[0].meta_data) {
                        this.formMetaDataInfo = JSON.parse(data.result[0].meta_data);
                    }

                    var timezoneVal = parseInt(this.assignment.csr_req_tz);
                    if (this.timezones.length) {
                        this.timezones.forEach((timezone: any) => {
                            if (timezoneVal == parseInt(timezone.val)) {
                                this.timezoneName = timezone.offset;
                                this.timezone = this.timezone.val;
                            }
                        });
                    }
                    this.assignment.update_note = '';
                    console.log('this.assignment:::', this.assignment, this.assignment.followup_date);
                    this.notes = data.notes;
                    this.assigned_admin = this.assignment.assigned_admin_name;
                    this.changeStatusParams = {
                        status: this.assignment.status,
                        notes: '',
                        followup_date: new Date(this.assignment.followup_date) > this.today ? new Date(this.assignment.followup_date) : this.today,
                        req_id: this.assignment.req_id,
                        type_of_call: this.assignment.contact_type,
                        result_of_contact: this.assignment.contact_result,
                    };
                    this.filterResult();
                    this.reassignParams = {
                        // admin_id: this.assignment.admin_id,
                        notes: '',
                        req_id: this.assignment.req_id
                    };
                    if (this.assignment && this.assignment.wp_query_id && this.assignment.wp_query_id > 0 && this.assignment.wp_type !== 1) {
                        this.getEmailSentRecordsForInquiry(this.assignment.req_id);
                        this.getSpeciality();
                    }

                }
            }, (error: any) => {
                console.log(error);
            })
    }

    /** ---------------- Terminal order tickets ---------------- */

    get isTerminalOrder(): boolean {
        return !this.is_lead && this.assignment?.action_type == TERMINAL_ORDER_ACTION_TYPE;
    }

    /** "Edit" once every device on the order has its shipment filled in. */
    get allDevicesShipped(): boolean {
        return this.terminalDevices.length > 0 && this.terminalDevices.every(hasShipmentDetails);
    }

    get shipmentBlockedReason(): string {
        if (this.assignment?.is_deleted == 1) {
            return 'This ticket has been deleted';
        }
        return this.terminalDevices.length ? '' : 'Terminal order not linked to this ticket';
    }

    get deliveryBlockedReason(): string {
        if (this.shipmentBlockedReason) {
            return this.shipmentBlockedReason;
        }
        return this.terminalDevices.some(device => device.ship_date) ? '' : 'Add shipment details first';
    }

    /** "1234 Main St., Apt 567, San Francisco, CA 94111, United States" */
    get deliveryAddressLine(): string {
        const address = this.deliveryAddress;
        if (!address) {
            return '';
        }
        const stateZip = [address.state, address.zip_code].filter(Boolean).join(' ');
        return [address.street_address || '-', address.city, stateZip, address.country].filter(Boolean).join(', ');
    }

    get terminalQuantity(): number {
        return Number(this.deliveryAddress?.device_quantity) || this.terminalDevices.length || 1;
    }

    get trackedDevices(): TerminalTicketDevice[] {
        return this.terminalDevices.filter(device => device.track_link);
    }

    terminalStatusLabel(status: string): string {
        return TERMINAL_TICKET_STATUS_OPTIONS.find(option => option.value === status)?.label || status;
    }

    terminalDate(value: string | null): Date | null {
        return parseLocalDate(value);
    }

    openTerminalShipmentModal(mode: TerminalShipmentModalMode, tdiId: number | null = null) {
        const blocked = mode === 'shipment' ? this.shipmentBlockedReason : this.deliveryBlockedReason;
        if (blocked) {
            this._shared.customPopups(blocked + '.', 2);
            return;
        }
        const modalRef = this.modalService.show(TerminalShipmentModalComponent, {
            initialState: { mode, tdiId, reqId: this.assignment.req_id, devices: this.terminalDevices },
            class: 'modal-dialog-centered ' + (mode === 'shipment' ? 'modal-lg' : ''),
            ignoreBackdropClick: true
        });
        modalRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.getAssignmentDetails(this.assignment.req_id);
            }
        });
    }

    getLeadRequestDetails(lead_id: any) {
        let data = {
            lead_id: lead_id
        };
        this._api.api(data, 'assignments/lead_request_details', 'get')
            .subscribe((data: any) => {
                let result = data && data.result && data.result.length ? data.result[0] : (data ? data.result : null);
                if (result) {
                    this.lead_request = result;
                    this.assignment = result;
                    this.notes = data.notes || [];
                    this.role = this._local.customGetItem('admin_profile') ? (this._local.customGetItem('admin_profile').role_id) : 0;
                    if (result.meta_data) {
                        this.formMetaDataInfo = JSON.parse(result.meta_data);
                    }
                    this.cd.detectChanges();
                }
            }, (error: any) => {
                console.log(error);
            })
    }

    setFollowDate() {
        this.changeStatusParams.followup_date = (this.assignment.followup_date && this._shared.getExactDate(new Date(this.assignment.followup_date))) > this.today ? this._shared.getExactDate(new Date(this.assignment.followup_date)) : this.today;
    }

    getEmailSentRecordsForInquiry(req_id: any) {
        let data = {
            emails: [],
            inquiry_id: req_id,
        };
        this._api.api(data, 'assignments/get_sent_email_records_of_an_inquiry')
            .subscribe((response: any) => {
                if (!response.err) {
                    if (response && response.inquiry_email_sent_records && response.inquiry_email_sent_records.length) {
                        var sent_emails = [];
                        for (var i = 0; i < response.inquiry_email_sent_records.length; i++) {
                            if (sent_emails.indexOf(response.inquiry_email_sent_records[i]["lead_doctor_email"]) === -1) {
                                sent_emails.push(response.inquiry_email_sent_records[i]["lead_doctor_email"]);
                            }
                        }
                        this.inquiry_email_sent_records = [];
                        for (var i = 0; i < sent_emails.length; i++) {
                            var sent_email = sent_emails[i];
                            var email_sent_records = response.inquiry_email_sent_records.filter((inquiry_email_sent_record: any) => inquiry_email_sent_record.lead_doctor_email === sent_email);
                            email_sent_records.sort((r1: any, r2: any) => {
                                return (r1.date_created > r2.date_created ? -1 : 1);
                            })
                            var number_of_email_sent = email_sent_records.length;
                            var doctorLeadObj = response.inquiry_email_sent_records.find((inquiry_email_sent_record: any) => inquiry_email_sent_record.lead_doctor_email === sent_email);
                            var doctorLeadName = doctorLeadObj ? (doctorLeadObj.doctor_name) ? (doctorLeadObj.doctor_name) : doctorLeadObj.lead_first_name && doctorLeadObj.lead_last_name ? (doctorLeadObj.lead_first_name + "" + doctorLeadObj.lead_last_name) : "" : "";
                            doctorLeadObj["full_name"] = doctorLeadName;
                            doctorLeadObj["number_of_email_sent"] = number_of_email_sent;
                            //doctorLeadObj["last_sent_date"] = moment(email_sent_records[0].date_created).format('MMM DD, YYYY [at] hh:mm A');
                            //   console.log(email_sent_records);
                            this.inquiry_email_sent_records.push(doctorLeadObj);
                        }

                    }
                }
            }, (error: any) => {
                console.log(error);

            });
    }

    resetForm(form: any, modal?: any) {
        if (form.dirty || (this.images && this.images.length > 0)) {
            var r = confirm("You have unsaved changes, do you want to continue?");
            switch (r) {
                case true:
                    break;
                case false:
                    return false;
                    break;
            }

        }
        form.reset();
        this.changeStatusParams.note = '';
        this.changeStatusParams.admin_id = '';
        this.reassignParams.note = '';
        this.changeStatusParams.followup_time = undefined;
        this.changeStatusParams.followup_hour = null;
        this.changeStatusParams.followup_minutes = null;
        if (modal) {
            modal.hide();
            this.images = [];
        }
        return true;
    }

    changeStatus(form: any, modal: any) {
        if ((this.changeStatusParams.status != 3 && this.changeStatusParams.status == this.assignment.status) && !this.changeStatusParams.admin_id) {
            this._shared.customPopups('Please select a new status or a CSR to re-assign', 2)
            this.cd.detectChanges();
            console.log('error')
            return false;
        }
        if ((!this.changeStatusParams.followup_hour || !this.changeStatusParams.followup_minutes) && this.changeStatusParams.status != 1) {
            this._shared.customPopups('Please select a valid followup time', 2)
            return false;
        }
        if (this.changeStatusParams.followup_date) {
            let followup_date = this.datePipe.transform(this.changeStatusParams.followup_date, 'yyyy-MM-dd');
            if (this.changeStatusParams.followup_hour && this.changeStatusParams.followup_minutes) {
                let time = new Date().getTimezoneOffset();
                let hours = Math.abs(Math.trunc(time / 60));
                let minutes = ("0" + time % 60).slice(-2);
                let user_timezone = '';
                if (time > 0) {
                    user_timezone = "-" + hours + minutes;
                } else {
                    user_timezone = "+" + hours + minutes;
                }
                let today_time = this._shared.getfollowupDateTimeInUTCToday(new Date(), user_timezone)
                let today_time_1 = new Date(today_time).getTime();
                let follow_up = this._shared.getfollowupDateTimeInUTC(followup_date + ` ${this.changeStatusParams.followup_hour}:${this.changeStatusParams.followup_minutes}:00`, this.timezone)
                let follow_up_time = new Date(follow_up).getTime();
                if (today_time_1 >= follow_up_time) {
                    this._shared.customPopups('Please select future time for followup', 2);
                    return false;
                } else {
                    this.changeStatusParams.followup_date = follow_up;
                }
            }
        }
        if (this.images && this.images.length > 0) {
            this.changeStatusParams['docs_urls'] = this.images.map((x: any) => x.image);
        }
        if (this.uploading) {
            this._shared.customPopups('Please wait while files are uploading', 2);
            return false;
        }
        if (this.changeStatusParams.status == 1) {
            delete this.changeStatusParams.followup_date;
        }
        this._api.api(this.changeStatusParams, 'assignments/change_and_reassign_csr_request_status')
            .subscribe((data: any) => {
                form.reset();
                modal.hide();
                this.images = [];
                this.imageURLs = [];
                this.getAssignmentDetails(this.assignment.req_id)
            }, (error: any) => {
                console.log(error);
            })
        return true;
    }

    reassignReq(form: any, modal: any) {
        if (!this.reassignParams.admin_id) {
            this._shared.customPopups('Please select CSR to re-assign', 2);
            return false;
        }
        this._api.api(this.reassignParams, 'reassign_csr_request')
            .subscribe((data: any) => {
                if (data.is_error == 0) {
                    this.getAssignmentDetails(this.assignment.req_id)
                    this.resetForm(form);
                    modal.hide();
                }
            }, (error: any) => {
                console.log(error);
            })
        return true;
    }

    addNote(form: any) {
        let dataParams: any = {
            notes: form.value.notes2,
            req_id: this.assignment.req_id
        };

        if (this.images && this.images.length > 0) {
            dataParams['docs_urls'] = this.images.map((x: any) => x.image);
        }
        if (this.uploading) {
            this._shared.customPopups('Please wait while files are uploading', 2);
            return false;
        }
        this._api.api(dataParams, 'assignments/add_csr_request_notes')
            .subscribe((data: any) => {
                if (data.is_error == 0) {
                    form.reset();
                    this.images = [];
                    this.imageURLs = [];
                    this.getAssignmentDetails(this.assignment.req_id)
                }
            }, (error: any) => {
                console.log(error);
            })
        return true;
    }

    selectAdmin(event: any) {
        this.changeStatusParams.admin_id = event;
        this.addNoteParams.admin_id = event;
    }

    adminClear(event: any) {
        if (event.length == 0) {
            this.addNoteParams.admin_id = '';
            this.changeStatusParams.admin_id = '';
        }
    }

    approveRejectModal(value: number) {
        this.addNoteParams['is_approved'] = value;
        if (this.assignment && this.assignment['assigned_id']) {
            this.addNoteParams.admin_id = this.assignment['assigned_id'];
        }
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.approveRejectModal,
                approve_extra_data: {
                    req_id: this.assignment.req_id,
                    is_approved: value || this.assignment.is_approved
                }
            },
            class: 'modal-dialog-centered modal-lg'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.getAssignmentDetails(this.assignment.req_id);
                this.addNoteParams.admin_id = '';
                this.assignment.is_approved = this.addNoteParams.is_approved;
                this.notes.unshift({
                    notes: this.addNoteParams.notes,
                    date_added: new Date(),
                    admin_name: this._local.customGetItem('admin_profile').admin_name
                })
            }
        })
    }

    // handleApproveReject(form: any, modal: any) {
    //     let params = {
    //         notes: this.addNoteParams.notes,
    //         req_id: this.assignment.req_id,
    //         is_approved: this.addNoteParams.is_approved,
    //         admin_id: this.addNoteParams.admin_id
    //     };
    //     this._api.api(params, 'approve_disapprove_csr_request')
    //         .subscribe((data: any) => {
    //             if (data.is_error == 0) {
    //                 modal.hide();
    //                 form.resetForm();

    //                 this.getAssignmentDetails(this.assignment.req_id);
    //             }
    //         }, (error: any) => {
    //             console.log(error);
    //         })

    // }

    getSpeciality() {
        this._api.api({
            fetch_all_sub_ind: 1,
            ignore_verified: 1,
        }, 'business/doctor_speciality_list', 'get')
            .subscribe((data: any) => {
                this.specialities = data.doctor_speciality;
                this.industries = [];
                this.specialities.forEach((spec: any) => {
                    if (spec.is_verified) {
                        if (!this.industries.filter((ind: any) => ind.ind_id === spec.ind_id).length) {
                            this.industries.push({
                                ind_id: spec.ind_id,
                                ind_is_guaranteed: spec.ind_is_guaranteed,
                                ind_name: spec.ind_name
                            });
                        }
                    }
                });
                this.industries.sort((ind1: any, ind2: any) => ind1.ind_id < ind2.ind_id ? -1 : 1);
                this.industries.map((ind: any) => {
                    ind["specialities"] = this.specialities.filter((spec: any) => spec.ind_id === ind.ind_id && spec.is_verified);
                    return ind;
                });
            }, (error: any) => {
                console.log(error);
            })
    }
    selectZip(e: any): void {
        var getZipData = this.loadingZip.data.filter((singleItem: any) => {
            return singleItem.zip == e;
        })
        if (getZipData) {
            this.assignment.wp_zip = getZipData[0].zip;
            this.assignment.wp_state_name = getZipData[0].state_name;
            this.assignment.wp_city_name = getZipData[0].city;
            this.assignment.city_id = getZipData[0].city_id;
        }
    }

    zipClear(event: any) {
        if (event.length == 0) {
            this.loadingZip.data = [];
        }
    }

    phoneChange(event: any) {
        this.newMobile = '+1-' + event.replace(/\D+/g, '');
    }
    resetUpdateForm() {
        this.loadingZip.data = [];
        this.getAssignmentDetails(this.requestId);
    }

    fileSelect(event: any) {
        if (this.images && this.images.length > 10) {
            this._shared.customPopups('Can not upload more than 10 files', 2);
            return false;
        }
        if (event && event.target && event.target.files && event.target.files.length > 0) {
            for (let file of event.target.files) {
                let selectedFile = { file: file };
                if ((selectedFile.file.size / 1024 / 1024) > 10) {
                    this._shared.customPopups('File size must be less than 10MB', 2);
                    return false;
                }
                if (selectedFile.file.type.indexOf('image/') === 0 || selectedFile.file.type.indexOf('application/') === 0) {
                    let index = this.images.findIndex((x: any) => x.file.mediaFile.name == selectedFile.file.name);
                    const reader = this.readFiles(selectedFile);
                    if (index < 0) {
                        this.images.push({ file: reader });
                        this.uploading = true;
                        this.uploadFile(reader, this.images.length - 1);
                        // this.imgElement.nativeElement.value = '';
                    }
                } else {
                    this._shared.customPopups('Please select valid file', 2);
                }
            }
        }
        return true;
    }

    readFiles(file: any) {
        file.mediaFile = file.file;
        file.file = this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file.mediaFile));
        return file;
    }


    uploadFile(item: any, index?: any) {
        this.uploading = true;
        this.images[index].uploading = true;
        const formData = new FormData();
        formData.append('file', item.mediaFile);
        this.images[index].uploadSub = this._http.post(environment.baseUrl + 'assignments/upload_csr_doc', formData, {
            reportProgress: true,
            observe: 'events'
        })
            .pipe(
                map((event: HttpEvent<any>) => {
                    let response: any = [];
                    if (event.type === HttpEventType.UploadProgress) {
                        const percentDone = Math.round(100 * event.loaded / (event.total || 1));
                        response = [{ status: 'progress', message: percentDone }];
                    }
                    if (event.type === HttpEventType.Response) {
                        response.push(event.body);
                    }
                    return response;
                })
            )
            .subscribe(d => {
                if (this.images && this.images[index]) {
                    this.images[index].subs = d;
                }
                this.fileSubscription = d;
                let success = d.every((item: any) => {
                    return item.status !== 'progress'
                });
                if (success) {
                    this.uploading = false;
                    this.images[index].uploading = false;
                    d.forEach((item: any) => {
                        this.imageURLs.push(item.images[0]);
                        this.images[index].image = item.images[0];
                    })

                } else {
                    this.uploading = true;
                    this.images[index].uploading = true;
                }
            });
    }


    // deletFile(file: any, index: any) {
    //     this.mainService.deleteServerFile(file)
    //         .subscribe((data: any) => {
    //             if (data && data.is_error == 0) {
    //                 this.images.splice(index, 1);
    //             }
    //         })
    // }

    cancelImageUpload(file: any, index: any) {
        this.images[index].uploadSub.unsubscribe();
        this.images[index].uploading = false;
        this.images.every((item: any) => {
            this.uploading = item.uploading
        });
        this.images.splice(index, 1);
    }
    ngOnDestroy() {
        if (this.paramSubscription) {
            this.paramSubscription.unsubscribe();
        }
        if (this.queryParamSubscription) {
            this.queryParamSubscription.unsubscribe();
        }
    }

    updateField(key: string, value: any) {
        this.changeStatusParams[key] = Number(value);
        if (key === 'type_of_call') {
            if ([6, 7, 8].includes(+value)) {
                this.changeStatusParams['result_of_contact'] = '';
            }
            const result_of_contact = this.allResultTypeArr.filter((result: any) => result.contact_id == value)[0];
            this.result_of_contact_arr = result_of_contact && result_of_contact.contact_data;
            if (!this.changeStatusParams['result_of_contact'] || value === 9) {
                this.changeStatusParams['result_of_contact'] = this.result_of_contact_arr[0].result_id;
            }
        }
    }

    getContactType() {
        const body = {
        };
        this._api.api(body, 'assignments/get_contact_types', 'get').subscribe(contactTypes => {
            if (!contactTypes.is_error) {
                if (contactTypes.data.length) {
                    this.type_of_call_arr = contactTypes.data;
                }
            }
        });
    }

    getResultType() {
        const body = {
        };
        this._api.api(body, 'assignments/get_result_of_contact', 'get').subscribe(resultsOfContact => {
            if (!resultsOfContact.is_error) {
                if (resultsOfContact.data.length) {
                    this.allResultTypeArr = resultsOfContact.data;
                    this.result_of_contact_arr = this.allResultTypeArr[0].contact_data;
                    // tslint:disable-next-line:max-line-length
                    this.filterResult();
                }
            }
        });
    }

    filterResult() {
        const result_of_contact = this.allResultTypeArr.filter((result: any) => result.contact_id == this.changeStatusParams.type_of_call);
        this.result_of_contact_arr = result_of_contact[0] && result_of_contact[0].contact_data;
        this.changeStatusParams['result_of_contact'] = this.assignment.contact_result;
    }

    setStatusForm() {
        this.changeStatusParams.status = this.assignment.status;
        this.changeStatusParams.type_of_call = this.assignment.contact_type;
        this.changeStatusParams.result_of_contact = this.assignment.contact_result;
        this.filterResult();
    }

    editShipmentModal() {
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.editShipmentModal,
                edit_shipment_data: {
                    req_id: this.assignment.req_id,
                    serial_number: this.assignment.serial_number,
                    tracking_number: this.assignment.tracking_number,
                    track_link: this.assignment.track_link,
                    carrier_name: this.assignment.carrier_name,
                    ship_date: this.assignment.ship_date,
                    est_delivery_date: this.assignment.est_delivery_date,
                    status: this.assignment.shipment_status,
                    send_delivery_email: true
                }
            },
            class: 'modal-dialog-centered modal-lg'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.getAssignmentDetails(this.assignment.req_id)
            }
        })
    }

    updateDeliveryModal() {
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.updateDeliveryModal,
                update_delivery_data: {
                    req_id: this.assignment.req_id,
                    delivery_date: this.assignment.delivery_date,
                    status: this.assignment.shipment_status
                }
            },
            class: 'modal-dialog-centered modal-md'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.getAssignmentDetails(this.assignment.req_id)
            }
        })
    }

    editSerialNumberModal() {
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.editSerialNumberModal,
                edit_serial_number_data: {
                    req_id: this.assignment.req_id,
                    serial_number: this.assignment.serial_number
                }
            },
            class: 'modal-dialog-centered modal-md'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.getAssignmentDetails(this.assignment.req_id)
            }
        })
    }

    changeStatusModal() {
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.changeStatusModal,
                change_status_data: {
                    req_id: this.assignment.req_id,
                    status: this.assignment.status,
                    assignment_status: this.assignment.status,
                    uploading: this.uploading,
                    images: this.images,
                    fileSubscription: this.fileSubscription,
                    imageURLs: this.imageURLs,
                    result_of_contact_arr: this.result_of_contact_arr,
                    type_of_call: this.assignment.contact_type,
                    result_of_contact: this.assignment.contact_result,
                    allResultTypeArr: this.allResultTypeArr,
                    type_of_call_arr: this.type_of_call_arr,
                    role: this.role,
                    phase_req_id: this.assignment.phase_req_id,
                    followup_date: this.assignment.followup_date,
                    api_request_type: this.api_request_type,
                }
            },
            class: 'modal-dialog-centered modal-lg'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.images = [];
                this.imageURLs = [];
                this.getAssignmentDetails(this.assignment.req_id)
            }
        })
    }

    addNoteModal() {
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.addNoteModal,
                change_status_data: {
                    req_id: this.assignment.req_id,
                    uploading: this.uploading
                }
            },
            class: 'modal-dialog-centered modal-lg'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.images = [];
                this.imageURLs = [];
                this.getAssignmentDetails(this.assignment.req_id)
            }
        })
    }

    updateInformationInquiryModal() {
        const modelRef = this.modalService.show(AssignmentsModalComponent, {
            initialState: {
                modalType: this._assignmentsService.modalTypes.updateInformationInquiryModal,
                update_extra_data: {
                    req_id: this.assignment.req_id,
                    industries: this.industries,
                    assignment: this.assignment,
                    wp_query_id: this.assignment.wp_query_id
                }
            },
            class: 'modal-dialog-centered modal-lg'
        })
        modelRef.content?.passEntry.subscribe(response => {
            if (response.success) {
                this.images = [];
                this.imageURLs = [];
                this.getAssignmentDetails(this.assignment.req_id)
            }
        })
    }

    viewDocument() {
        let param = {
            req_id: this.requestId
        };
        this._api.api(param, 'assignments/get_dispute_documents', 'get').subscribe({
            next: (data) => {
                this.dispute_docs = data.final_data ? data.final_data : {};
                const modelRef = this.modalService.show(AssignmentsModalComponent, {
                    initialState: {
                        modalType: this._assignmentsService.modalTypes.viewDocuments,
                        document_data: {
                            documents: this.dispute_docs,
                            assignment_detail: this.assignment
                        }
                    },
                    class: 'modal-dialog-centered modal-lg'
                })
                modelRef.content?.passEntry.subscribe(response => {
                    if (response.success) {
                        this.getAssignmentDetails(this.assignment.req_id)
                    }
                })
            },
            error: (error) => {
                console.log(error, "error");

            }
        })
        // this.dispute_docs = {
        //     remaining_documents : [{value: "doc 1"},{value: "doc 2"},{value: "doc 3"},{value: "doc 4"},{value: "doc 5"}],
        //     uploaded_documents : [{value: "doc 1"},{value: "doc 2"},{value: "doc 3"},{value: "doc 4"},{value: "doc 5"}]
        // }


    }
}
